import {Component} from "@angular/core";
import {environment} from "environments/environment";
import {Router} from "@angular/router";
import {AppPermissionService} from "app/core/services/app-permission.service";
import {PermissionResponse} from "app/core/base-api";
import {FormatConfigService} from 'app/core/services/format-config.service';
import {CapiLoginService} from 'app/core/extension/login/capi-login-service';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-app-decider',
  templateUrl: './app-decider.component.html'
})
export class AppDeciderComponent {

  public deploymentMode = environment.deploymentMode;

  constructor(
    private permissionService: AppPermissionService,
    private router: Router,
    private appformatConfigService: FormatConfigService,
    private loginService: CapiLoginService) {
    const permission = this.getNecessaryPermission();
    if (loginService.userLoggedIn && !this.permissionService.hasPermission(permission) && permission !== PermissionsEnum.ANONYM) {
      this.router.navigate(['unauthorized']);
    }
  }

  private getNecessaryPermission(): PermissionResponse.PermissionsEnum {
    if (this.deploymentMode === "PUBLIC") {
      const loginICPRequired = <any>this.appformatConfigService.parameterConfig?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'REGISTRIERT';
      if (!loginICPRequired) {
        return PermissionsEnum.ANONYM;
      }
      return PermissionsEnum.ICPAUTHORIZED;
    } else if (this.deploymentMode === "READ") {
      return PermissionsEnum.LOGIN;
    }
  }
}
